import React, { useEffect, useState } from 'react';
import { DatePicker } from 'rsuite';
import { edit_prod_planner_schedule } from '../utilis/productionPlannerServices.js';

const RSuiteDatePicker = ({
  id,
  field,
  row,
  rowNode,
  colDef,
  cellMode,
  hasFocus,
  tabIndex,
  formattedValue,
  isEditable,
  api,
}) => {
  // console.log(row);
  const [dt, setDt] = useState(null);
  useEffect(() => {
    if (row[field]) {
      setDt(new Date(row[field]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = async (e) => {
    const date = new Date(e);
    const dd = date.getDate();
    const mm = date.getMonth();
    const yyyy = date.getFullYear();
    const hh = date.getHours();
    const min = date.getMinutes();
    const ss = date.getSeconds();

    const d = `${yyyy}-${mm + 1}-${dd} ${hh}:${min}:${ss}`;
    const { batch_no } = row;
    const material_type = (() => {
      switch (row.sample_type) {
        case "SFG(without micro)":
          return "INTM";
        case "SFG(with micro)":
          return "INTM";
        case "FP(without micro)":
          return "FP";
        case "FP(with micro)":
          return "FP";
        case "CB(urgent)":
          return "CB";
        case "CB(additional)":
          return "CB";
        case "CB":
          return "CB";
        default:
          return row.sample_type;
      }
    })();
    const expected_delivery_date_by_production = d;
    const response = await edit_prod_planner_schedule({ batch_no, expected_delivery_date_by_production, material_type });
    if (response.status) {
      setDt(e);
      alert(response.message);
      api.updateRows([{ id, [field]: e }]);
    }
    else {
      alert(response.message);
    }
  };
  return (
    <div>
      <DatePicker
        format='yyyy-MM-dd HH:mm'
        calendarDefaultDate={dt}
        style={{ width: 200 }}
        value={dt}
        onChange={handleChange}
      />
    </div>
  );
};

export default RSuiteDatePicker;